import { asyncThunkWrapper } from "../handleAsyncThunk"
import { BASEURI, headers } from "../../utils/helper"
import { createAsyncThunk } from "@reduxjs/toolkit"

// Handle retrieve all webinars
export const handleRetrieveAllWebinars = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      type: data?.type || null,
      limit: data?.limit || null,
      search: data?.search || null,
      status: data?.status || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/admin/webinar/retrieve-all`,
      },
      thunkAPI,
      { showToast: false }
    )
  }
)

// Handle delete Webinar
export const handleDeleteWebinar = createAsyncThunk(
  "delete",
  async (id, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "DELETE",
        headers: headers(),
        url: `${BASEURI}/admin/webinar/delete/${id}`,
      },
      thunkAPI
    )
)

// Handle update Webinar
export const handleUpdateWebinar = createAsyncThunk(
  "update",
  async (data, thunkAPI) =>
    asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        data: data?.formData || {},
        url: `${BASEURI}/admin/webinar/update/${data?.id}`,
      },
      thunkAPI
    )
)

// Handle retrieve webinar
export const handleRetrieveWebinar = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/admin/webinar/retrieve/${id}`,
      },
      thunkAPI,
      { showToast: false }
    )
  }
)

// Handle retrieve bookings (webinar)
export const handleRetrieveBookings = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/admin/booking/webinar/${data?.id}`,
      },
      thunkAPI,
      { showToast: false }
    )
  }
)
